export function isMtvNews247Id(id: string | undefined): boolean {
  return id === "20025962" || id === "9e6393959b5c6ccb71ea";
}
